export default __webpack_public_path__ + "static/media/cp_geo_cy.6a8cb308.svg";